import { createLocalStorageStateHook } from "use-local-storage-state";

export default createLocalStorageStateHook<boolean>("audio", true);
